import LR from "./LR.layout"
import pad from "./pad.layout"
import pc from "./pc.layout"
import pc3 from "./pc3.layout"
import top from "./top.layout"
import vs from "./vs.layout"
const layouts =[
    LR,
    pad,
    pc,
    pc3,
    top,
    vs
]


function findLayout(name) {
    
    const tt = layouts.filter(t => t.name === name)
    if (tt.length > 0) return tt[0]
    else return null
}
function registerLayout(layout) {
    if (!layout) throw new Error("layout is null")
    if (!layout.name || !layout.text || !layout.minWidth || !layout.maxWidth || !layout.layout)
        throw new Error("bad format layout,help:{name:string,text:string,layout:function,minWidth:number,maxWidth:number}")

    if (layouts.filter(t => t.name === layout.name).length > 0) {
        throw new Error(`${layout.name} existed,please rename the layout name`)
    }
    layouts.push(layout)
}

export default {
    layouts,
    findLayout,
    registerLayout,
    defaultLayout: findLayout("top")
}